<template>
    <div class="tournament-sub-list-wrap">
        <div class="tournament-sub-list" v-if="processingTournaments.tournamentList.length > 0">
            <p class="title">현재 접수중인 대회 <span>{{processingTournaments.tournamentList.length}}건</span></p>
            <div class="tournament-sub-content-wrap">
                <TournamentSubContent v-for="tournament in processingTournaments.tournamentList" :key="tournament.tnmtId"
                                      :tournament="tournament"></TournamentSubContent>
            </div>


        </div>
        <div class="tournament-sub-list" v-if="goingTournaments.tournamentList.length > 0">
            <p class="title">현재 진행중인 대회<span>{{goingTournaments.tournamentList.length}}건</span></p>
            <div class="tournament-sub-content-wrap">
                <TournamentSubContent v-for="tournament in goingTournaments.tournamentList" :key="tournament.tnmtId"
                                      :tournament="tournament"></TournamentSubContent>
            </div>
        </div>

    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import TournamentSubContent from './TournamentSubContent'

    export default{
        computed: {
            ...mapState('tournaments', ['goingTournaments', 'processingTournaments']),

        },
        components: {
            TournamentSubContent
        }
    }
</script>